import { useEffect, useState } from 'react';

const matchesQuery = (query: string): boolean =>
  typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false;

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState<boolean>(() => matchesQuery(query));

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;

    const mediaQueryList = window.matchMedia(query);
    const handleChange = (event: MediaQueryListEvent): void => setMatches(event.matches);

    setMatches(mediaQueryList.matches);
    mediaQueryList.addEventListener('change', handleChange);

    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
};
